import React from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'
import _ from 'lodash'
import { BusinessUnitMultiSelect } from '../../fields'

const HospitalModal = ({
  modalIsOpen,
  closeModal,
  inputs,
  zones,
  businessunits,
  handleChange,
  handleBusinessUnitsChange,
  handleSubmit,
  validateForm,
  textBtn,
  isEdit = false, // Nueva prop para determinar si es edición o creación
  isViewMode = false, // Nueva prop para modo de solo lectura
}) => {
  const customStyles = {
    content: {
      width: '80%',
      maxWidth: '800px',
    },
  }

  const sortedZones = _.orderBy(zones, ['nombre'], ['asc'])

  // Títulos dinámicos según el modo
  const modalTitle = isViewMode
    ? 'Ver hospital'
    : isEdit
    ? 'Editar hospital'
    : 'Alta nuevo hospital'
  const contentLabel = isViewMode
    ? 'Ver hospital'
    : isEdit
    ? 'Editar hospital'
    : 'Alta nuevo hospital'

    return (
    <ReactModal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel={contentLabel}
      className='custom-modal'
      style={customStyles}
    >
      <span className='custom-modal__close close-btn' onClick={closeModal}>
        <CloseBtn />
      </span>
      <h4 className='custom-modal__title'>{modalTitle}</h4>
      <Form onSubmit={handleSubmit} className='hospital__form'>
        {/* Primera fila: 3 columnas */}
        <div className='hospital-form-row hospital-form-row--three'>
          <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Código interno <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='codigo'
                value={inputs.codigo !== null ? inputs.codigo : ''}
                onChange={handleChange}
                placeholder='Código interno'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
          <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Nombre hospital <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='nombre'
                value={inputs.nombre !== null ? inputs.nombre : ''}
                onChange={handleChange}
                placeholder='Nombre'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
          <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Población <RequieredInputs />
              </Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='poblacion'
                value={inputs.poblacion !== null ? inputs.poblacion : ''}
                onChange={handleChange}
                placeholder='Población'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
        </div>

        {/* Segunda fila: 3 columnas */}
        <div className='hospital-form-row hospital-form-row--three'>
          {/* <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>
                Zona <RequieredInputs />
              </Form.Label>
              <Form.Control
                as='select'
                className='user-input form__input'
                name='id_TipoZona'
                onChange={handleChange}
                value={inputs.id_TipoZona}
                disabled={isViewMode}
              >
                <option hidden>Elegir zona</option>
                {sortedZones.length > 0
                  ? sortedZones.map((zone) => (
                      <option key={zone.id_TipoZona} value={zone.id_TipoZona}>
                        {zone.nombre}
                      </option>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </div> */}
          <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Dirección</Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='direccion'
                value={inputs.direccion}
                onChange={handleChange}
                placeholder='Dirección'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
          <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Comunidad</Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='comunidad_Autonoma'
                value={
                  inputs.comunidad_Autonoma !== null
                    ? inputs.comunidad_Autonoma
                    : ''
                }
                onChange={handleChange}
                placeholder='Comunidad'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
        </div>

        {/* Tercera fila: 2 columnas */}
        {/* <div className='hospital-form-row hospital-form-row--two'> */}
          {/* <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>País</Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='pais'
                value={inputs.pais !== null ? inputs.pais : ''}
                onChange={handleChange}
                placeholder='País'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div> */}
          {/* <div className='hospital-form-field'>
            <Form.Group size='lg'>
              <Form.Label className='form__labels'>Idioma</Form.Label>
              <Form.Control
                className='user-input form__input'
                type='text'
                name='idioma'
                value={inputs.idioma !== null ? inputs.idioma : ''}
                onChange={handleChange}
                placeholder='Idioma'
                readOnly={isViewMode}
              />
            </Form.Group>
          </div>
        </div> */}

        {/* Cuarta fila: Unidades de Negocio */}
        <div className='hospital-form-row hospital-form-row--business-units'>
          <div className='hospital-form-field'>
            <BusinessUnitMultiSelect
              value={
                inputs.businessUnits && Array.isArray(inputs.businessUnits)
                  ? isEdit
                    ? inputs.businessUnits.map((bu) => bu.id_NegocioUnidad) // Para edición: extraer IDs de objetos
                    : inputs.businessUnits // Para creación: ya son IDs
                  : []
              }
              onChange={handleBusinessUnitsChange}
              label='Unidades de Negocio'
              placeholder='Selecciona las unidades de negocio para este hospital...'
              required
              compact
              disabled={isViewMode}
            />
          </div>
        </div>

        {!isViewMode && (
          <button
            onClick={handleSubmit}
            disabled={!validateForm()}
            className='btn save create'
          >
            {textBtn}
          </button>
        )}
      </Form>
    </ReactModal>
  )
}

ReactModal.setAppElement('#root')
export default HospitalModal
